module.exports = __webpack_public_path__ + "img/map-vic.33a12bdd.png";